import { Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable =
    (Component, options = {}) =>
    (props) => {
        const { loader: LoaderComponent = Loader } = options;

        return (
            <Suspense fallback={<LoaderComponent />}>
                <Component {...props} />
            </Suspense>
        );
    };

export default Loadable;
